import InfoMessage from "./InfoMessage";

export default function Loading() {
  return <InfoMessage>Loading...</InfoMessage>;
}
